import {BrowserRouter as Router, Navigate, Route, Routes} from "react-router-dom";
import React from "react";
import Dashboard from "../avaluacio/Dashboard";
import Projectes from "../avaluacio/projectes/Projectes";
import ProjectesId from "../avaluacio/projecteId/ProjectesId";
import ProjectesIdGrupIdAvaluacio from "../avaluacio/projecteIdGrupIdAvaluacio/ProjectesIdGrupIdAvaluacio";
import Avaluacions from "../avaluacio/projectes/content/Avaluacions";

const AppJutgeRoutes = () => {

    return (
        <Routes>
            <Route path="/" element={<Dashboard/>}/>
            <Route path="/projectes" element={<Projectes/>}/>
            <Route path="/avaluacions" element={<Avaluacions/>}/>
            <Route path="/projectes/:id_projecte" element={<ProjectesId/>}/>
            <Route path="/projectes/:id_projecte/grups/:id_grup" element={<ProjectesId/>}/>
            <Route path="/projectes/:id_projecte/grups/:id_grup/avaluacio" element={<ProjectesIdGrupIdAvaluacio/>}/>
            <Route path="*" element={<Navigate to="/" replace/>}/>
        </Routes>
    );
}

export default AppJutgeRoutes;